import React from "react";
import { t } from "../../../../../utils/i18n";

const Header = ({ offer, offerTypeDisplay, bankAccounts }) => {
  return (
    <div className=" page-header d-flex align-items-center pb-1 pt-3 bg-transparent">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div>
            <h2 className="create-trade-page-title">
              <i className="material-icons">add_circle</i>
              {t("p2p.create_trade.title")}
            </h2>
            <h3 className="tracking-tighter">
              {offer.cryptoCurrency
                ? t("p2p.create_trade.heading", {
                    action:
                      offerTypeDisplay === ""
                        ? ""
                        : offerTypeDisplay === "buy"
                        ? t("p2p.common.buy")
                        : t("p2p.common.sell"),
                    token:
                      offer.cryptoCurrency?.code == "USDT"
                        ? "USD"
                        : offer.cryptoCurrency?.code,
                    method: offer.paymentMethod?.name,
                    currency: offer.fiatCurrency?.code,
                  })
                : ""}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
